import React from 'react';

import './index.module.less';

import { PullRefresherProps, IPullRefresher } from './index.d';

class PullRefresher extends React.Component<PullRefresherProps> implements IPullRefresher {
  refresher?: HTMLDivElement;
  parent?: HTMLElement | null;
  isRefreshing?: boolean;

  componentDidMount(): void {
    this.parent = (this.refresher as HTMLDivElement).parentElement;
    if(!this.parent) {
      throw new Error('PullRefresher must have a parent element');
    }
    this.controlScrollEventBinding(this.props.disabled);
  }

  shouldComponentUpdate(nextProps: PullRefresherProps): boolean {
    return nextProps.disabled !== this.props.disabled || nextProps.loadingText !== this.props.loadingText;
  }

  // TODO: should be replaced with componentDidUpdate
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps: PullRefresherProps): void {
    if(this.props.disabled !== nextProps.disabled) {
      this.controlScrollEventBinding(nextProps.disabled);
    }
  }

  componentWillUnmount(): void {
    this.controlScrollEventBinding(true);
  }

  handleScroll = (): void => {
    if(this.isRefreshing) {
      return;
    }
    this.isRefreshing = true;

    window.requestAnimationFrame(() => {
      //如果滚动位置处于directive元素附近（距离为distance范围内）
      //offsetTop: 返回当前元素相对于其 offsetParent 元素的顶部的距离
      //offsetParent: 返回一个指向最近的（指包含层级上的最近）包含该元素的定位元素
      //clientHeight: 返回元素内部的高度(单位像素)，包含内边距，但不包括水平滚动条、边框和外边距
      const spacing = this.refresher.offsetTop - this.parent.clientHeight - this.parent.scrollTop;
      if(spacing <= (this.props.distance as number)) {
        this.props.onRefresh();
      } else {
        this.reset();
      }
    });
  }

  reset = (): void => {
    this.isRefreshing = false;
  }

  getRefresherElement = (element: HTMLDivElement): void => {
    this.refresher = element;
  }

  controlScrollEventBinding(disabled?: boolean | null): void {
    if(disabled) {
      this.parent.removeEventListener('scroll', this.handleScroll, false);
    } else {
      this.parent.addEventListener('scroll', this.handleScroll, false);
    }
  }

  render(): JSX.Element {
    const { disabled, loadingText } = this.props;
    const hideClass = disabled ? ' hide' : '';

    return (
      <div
        className={ 'flex' + hideClass }
        styleName="refresher"
        ref={ this.getRefresherElement }
      >
        <i className="seewo-loading infinite-rotate" />
        <span>{ loadingText }</span>
      </div>
    );
  }

  static defaultProps = {
    distance: 100, // 距离底部高度
    loadingText: '加载中...', // 上拉刷新显示文字
    disabled: false, // 是否禁用组件
    onRefresh: () => {} // 刷新回调函数
  }

}

export default PullRefresher
